import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import {
  Button,
  Layout,
  Icon,
  Menu,
  Result,
  Form,
  Input,
  Checkbox,
  Switch,
  Drawer,
  PageHeader,
  Card,
  Table,
  Select,
  Tag,
  Divider,
  Popconfirm,
  ConfigProvider,
  FormModel,
  List,
  Tabs,
  Modal,
  Radio,
  Alert,
  AutoComplete,
  Row,
  Col,
  Descriptions,
  message,
  InputNumber,
  Spin,
  Tooltip,
  Badge,
} from "ant-design-vue";
import Authorized from "./components/Authorized";
import Permission from "./router/permission";
import Vuex from "vuex";

export const EventBus = new Vue();

Vue.config.productionTip = false;
Vue.use(Button);
Vue.use(Layout);
Vue.use(Icon);
Vue.use(Menu);
Vue.use(Result);
Vue.use(Form);
Vue.use(Input);
Vue.use(Checkbox);
Vue.use(Switch);
Vue.use(Drawer);
Vue.use(PageHeader);
Vue.use(Card);
Vue.use(Table);
Vue.use(Select);
Vue.use(Tag);
Vue.use(Divider);
Vue.use(Popconfirm);
Vue.use(ConfigProvider);
Vue.use(FormModel);
Vue.use(List);
Vue.use(Tabs);
Vue.use(Modal);
Vue.use(Radio);
Vue.use(Alert);
Vue.use(AutoComplete);
Vue.use(Row);
Vue.use(Col);
Vue.use(Descriptions);
Vue.use(message);
Vue.use(InputNumber);
Vue.use(Spin);
Vue.use(Tooltip);
Vue.use(Badge);
Vue.component("Authorized", Authorized);
Vue.use(Permission);
Vue.use(Vuex);

Vue.prototype.$message = message;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
